// extracted by mini-css-extract-plugin
export default {"ionSpinner":"FacilityIcon_ionSpinner__UE8wg","spinnerContainer":"FacilityIcon_spinnerContainer__6B8gW"};